import React from 'react';
import { SiteShellProps } from 'src/config/sites/SiteDefinition';

const DefaultSiteShell: React.FC<SiteShellProps> = ({ children }) => <>{children}</>;

export default DefaultSiteShell;
